<template lang="pug">
.content-wrap
	.content-top
		.con.content-div.pb-0
			.wrap
				// Section 1: Hero Banner
				a(href='https://docs.google.com/forms/d/e/1FAIpQLSeRzetIatnr8-y-R9ytasuu0rfld7VE8m5nXwJ0xgZa5Zlsow/viewform' target='_blank' rel='noopener')
					img.section-img(src='/new/img/contact-page/image-01.webp' alt='Complaint Center Banner')
				// Section 2: Complaint Manager
				img.section-img.mt-2(src='/new/img/contact-page/image-02.webp' alt='Complaint Manager')
				// Section 3: We Listen to Every Player
				img.section-img.mt-section.padded-img(src='/new/img/contact-page/image-03.webp' alt='We Listen to Every Player')
				img.section-img(src='/new/img/contact-page/image-04.webp' alt='Received Reviewed Resolved')
				// Section 4: How to Submit
				img.section-img.mt-section(src='/new/img/contact-page/image-05.webp' alt='How to Submit a Complaint Steps')
				// Sticky Submit Button (fixed at bottom)
				a.sticky-btn(href='https://docs.google.com/forms/d/e/1FAIpQLSeRzetIatnr8-y-R9ytasuu0rfld7VE8m5nXwJ0xgZa5Zlsow/viewform' target='_blank' rel='noopener')
					img(src='/new/img/contact-page/image-06.webp' alt='Submit Complaint')
				// Section 5: Why Players Trust EpicWin
				img.section-img.mt-section(src='/new/img/contact-page/image-07.webp' alt='Why Players Trust EpicWin')
				img.section-img.padded-img(src='/new/img/contact-page/image-08.webp' alt='Your Privacy')
				// Footer
				//- .footer-social
					.footer-social-left
						img.follow-label(src='/new/img/contact-page/image-09.webp' alt='Follow Us')
					img.trustpilot-img(src='/new/img/contact-page/image-10.webp' alt='Trustpilot')
		.con.pt-0
			footerInfo(:target="'/contactUs'")
</template>
<script>
import config from "@/config";
import footerInfo from '@/views/default/_footerArticle.vue'
export default {
	components:{
		footerInfo
	},
	data(){
		return{
			feedback: {
        success: true,
        status: ""
      },
			loading:false,
		}
	},
	computed:{
	},
	created(){
		$('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/contactUs`);
	},
	mounted(){
		window.scroll(0,0)
	},
	methods:{
	}
}
</script>
<style lang="scss" scoped>

.content-div {
	background: #0a0014;
	font-family: sans-serif;
}
.wrap {
	max-width: 1080px;
	margin: 0 auto;
	// padding: 0 10px 70px;
}
.section-img {
	display: block;
	width: 100%;
	height: auto;
}
.footer-social {
	background: #0a0014;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 18px 40px 24px;
}
.footer-social-left {
	display: flex;
	align-items: center;
	gap: 10px;
	flex-wrap: wrap;
}
.follow-label {
	display: block;
	width: auto;
	height: 28px;
}
.social-icon {
	display: block;
	width: auto;
	height: 36px;
}
.trustpilot-img {
	display: block;
	width: auto;
	height: 64px;
}
.mt-section {
	margin-top: 30px;
}
.padded-img {
	display: block;
	width: 100%;
	padding: 0 24px;
	box-sizing: border-box;
	height: auto;
}
.sticky-btn {
	// position: fixed;
	// bottom: 0;
	// left: 0;
	// right: 0;
	width: 100%;
	text-align: center;
	z-index: 999;
	display: block;
	line-height: 0;
	cursor: pointer;
	text-decoration: none;
	transition: filter 0.2s ease, transform 0.15s ease;
	animation: pulseGlow 2s ease-in-out infinite;
	@media(max-width: 767px){
		position: fixed;
		bottom: 70px;
		left: 0;
	}
}
.sticky-btn img {
	display: block;
	width: 100%;
	height: auto;
	@media(min-width: 768px){
		width: auto;
		margin: 0 auto
	}
}
.sticky-btn:hover {
	filter: brightness(1.15) drop-shadow(0 0 18px #f5c200cc);
	transform: scaleY(1.04);
	animation: none;
}
.sticky-btn:active {
	filter: brightness(0.9);
	transform: scaleY(0.97);
}
@keyframes pulseGlow {
	0%, 100% { filter: brightness(1) drop-shadow(0 0 6px #f5c20066); }
	50%       { filter: brightness(1.08) drop-shadow(0 0 20px #f5c200bb); }
}

</style>